import { render } from "./UiTable2.vue?vue&type=template&id=4b94eb1a&scoped=true&ts=true"
import script from "./UiTable2.vue?vue&type=script&lang=ts"
export * from "./UiTable2.vue?vue&type=script&lang=ts"

import "./UiTable2.vue?vue&type=style&index=0&id=4b94eb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b94eb1a"]])

export default __exports__